export default __webpack_public_path__ + "static/media/image2.3183ae5b.svg";